import { useEffect } from "react";

import { useAppDispatch } from "app/redux-store-interactions";
import { explorerActions } from "slices/explorer";

/**
 * Keeps the `explorer.isOnline` redux state in sync with the browser's
 * `online`/`offline` events. Mount once at the top of each entry point
 * (standalone app and embedded webviewer) so downstream UI can react to
 * connectivity changes.
 */
export function useHandleIsOnline() {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const handleOnline = () => dispatch(explorerActions.toggleIsOnline(true));
        const handleOffline = () => dispatch(explorerActions.toggleIsOnline(false));
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, [dispatch]);
}
